"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intOnly = void 0;
const intOnly = value => {
  return value.replace(/[^0-9]/g, '');
};
exports.intOnly = intOnly;